import styled from '@emotion/styled';
import { StyledProps, Theme } from './Tooltip.types';

export const StyledTooltipWrapper = styled.div<StyledProps, Theme>`
  ${(p) =>
    p.tooltipWrapperCss &&
    { left: 'flex-direction: row-reverse;', right: 'flex-direction: row;' }[p.iconHorizontal || 'right']}
  ${(p) => p.showIcon && 'display: flex;'}
${(p) => p.tooltipWrapperCss && p.tooltipWrapperCss}
`;

export const StyledActiveContainer = styled.div<StyledProps, Theme>`
  ${(p) =>
    ({
      top: 'align-self: flex-start;',
      middle: 'align-self: center;',
      bottom: 'align-self: flex-end;',
    }[p.iconVertical || 'middle'])}
  ${(p) => p.ActiveContainerCss && p.ActiveContainerCss}
`;

export const StyledIconContainer = styled.div<StyledProps, Theme>`
  ${(p) =>
    ({
      top: 'align-self: flex-start;',
      middle: 'align-self: center;',
      bottom: 'align-self: flex-end;',
    }[p.iconVertical || 'middle'])}
  ${(p) => ({ left: 'margin-right: 10px;', right: 'margin-left: 10px;' }[p.iconHorizontal || 'right'])}
  ${(p) => p.iconContainerCss && p.iconContainerCss}
`;

export const StyledTitleContainer = styled.div<StyledProps, Theme>`
  margin-bottom: 1rem;
  ${(p) => p.titleContainerCss && p.titleContainerCss}
`;

export const StyledTooltipContent = styled.div<StyledProps, Theme>`
  width: 270px;
  padding: 10px;
  ${(p) => p.tooltipContentCss && p.tooltipContentCss}
`;

export const StyledChildContainer = styled.div<StyledProps, Theme>`
  ${(p) => p.tooltipChildCss && p.tooltipChildCss}
`;
